<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['emp.apptype.apptypeName']">
          <a-input v-model="model.appTypeName" readOnly disabled/>
        </a-form-item>
        <a-form-model-item :label="language['portal.unitApp']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="selectedApps">
          <j-multi-select-tag :maxTagCount="20"
            v-model="model.selectedApps"
            :options="appsOptions"
            :disabled="disableSubmit"
            :placeholder="language['common.pleaseChoose']+language['portal.unitApp']">
          </j-multi-select-tag>
        </a-form-model-item>


      </a-form>

    </a-spin>
  </a-modal>
</template>

<script>
import { get, pick } from 'lodash';
  import { httpAction, getAction } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate.vue';
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: "ApptypeApplicationModal",
    components: {
      JDate,
      JSelectUserByDep
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
        },
        url: {
          add: "/hhemp/apptype/empbaseapptype",
          edit: "/hhemp/apptype/empbaseapptype",
          queryByUserName:"/sys/sysUserAgent/queryByUserName",
        },
        apptypeId:"",
        appTypeName:"",
        id:"",
        entranceId:"",
        appsOptions:[],
      }
    },
    created () {
      this.initAppList();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      appTypeSet(apptypeId,appTypeName,entranceId){
        this.apptypeId = apptypeId;
        this.id = apptypeId;
        this.entranceId = entranceId;
        this.appTypeName = appTypeName;
        this.edit({apptypeId:this.apptypeId,appTypeName:this.appTypeName,selectedApps: '',id:this.id,entranceId:this.entranceId});

      },
      edit (record) {

        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.getAppTypeApps(this.apptypeId);

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            /*if(!this.model.apptypeId){
              httpurl+=this.url.add;
              method = 'post';
            }else{*/
              httpurl+=this.url.edit;
               method = 'put';
            /*}*/
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                //this.init();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })



          }
        })
      },
      handleCancel () {
        this.close()
      },
      //初始化应用list
      initAppList(){
        getAction("/sys/portal/sysPortalOrg/getAllAppsContainThird?applicationStatus=1").then((res)=>{
          if(res.success){
            this.appsOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.applicationName, value:item.id}
              return c;
            })
          }
        })
      },
      getAppTypeApps(apptypeId){
        getAction("/sys/portal/sysPortalOrg/getAppTypeApps",{id:apptypeId}).then((res)=>{
          if(res.success){
            this.model.selectedApps = res.result.join(",");
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>